export default __webpack_public_path__ + "static/media/error-page.5767d98b.webp";